export enum ComponentGroup {
  PersonalInfo = 'PersonalInfo',
  ResidenceInfo = 'ResidenceInfo',
  EmploymentInfo = 'EmploymentInfo',
  AdditionalInfo = 'AdditionalInfo',
  ReviewInfo = 'ReviewInfo',
  BankOffer = 'BankOffers',
  CoBuyerPersonal = 'CoBuyerPersonal',
  CoBuyerResidence = 'CoBuyerResidence',
  CoBuyerEmployment = 'CoBuyerEmployment',
  CoBuyerAdditional = 'CoBuyerAdditional',
  ConfirmationPage = 'ConfirmationPage',
  UnlockCreditApp = 'UnlockCreditApp',
  PersonalInfoLegacyCA = 'PersonalInfoCA',
  PrequalLegacyCA = 'PrequalLegacyCA'
}
